import { memo, useMemo, ReactNode } from 'react'
import Styles from './LinearGradient.module.scss'

interface Props {
  userId: number
  children?: ReactNode
  darken?: number
}

const hashCode = (string: string): number => {
  const encodedString = btoa(string)
  let hash = 0

  if (encodedString.length === 0) {
    return hash
  }

  for (let i = 0, j = encodedString.length; i < j; i++) {
    const char = encodedString.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  return hash
}

const LinearGradient = ({ userId, children, darken }: Props) => {
  const hash = useMemo(() => hashCode(userId + ''), [userId])
  const hue = hash % 359
  const contrastHue = hue - (60 % 359)
  let lightness = 50
  let contrastLightness = 85

  if (darken) {
    lightness = lightness - darken
    contrastLightness = contrastLightness - darken
  }

  return (
    <div
      className={Styles.gradient}
      style={{
        background: `linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(135deg, hsl(${hue}, 100%, ${lightness}%) 0%, hsl(${contrastHue}, 100%, ${contrastLightness}%) 100%)`,
      }}
    >
      {children}
    </div>
  )
}

const MemoizedLinearGradient = memo(LinearGradient)

export { MemoizedLinearGradient as LinearGradient }
